import { render } from "./NuovoCorso.vue?vue&type=template&id=0bcaa1f6&scoped=true"
import script from "./NuovoCorso.vue?vue&type=script&lang=js"
export * from "./NuovoCorso.vue?vue&type=script&lang=js"

import "./NuovoCorso.vue?vue&type=style&index=0&id=0bcaa1f6&lang=css"
import "./NuovoCorso.vue?vue&type=style&index=1&id=0bcaa1f6&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcaa1f6"]])

export default __exports__